module.exports = __webpack_public_path__ + "static/media/player_levelup.f59fafec.png";